import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getEmailDomainSuppliersList = createApi(`GetEmailDomainSupplierListSlice`,"GET");

const GetEmailDomainSupplierListSlice = createSlice({
  name: 'GetEmailDomainSupplierListSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEmailDomainSuppliersList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getEmailDomainSuppliersList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getEmailDomainSuppliersList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetEmailDomainSupplierListSlice.reducer;